import { render } from "./GalleryComponent.vue?vue&type=template&id=b936f1b6"
import script from "./GalleryComponent.vue?vue&type=script&lang=js"
export * from "./GalleryComponent.vue?vue&type=script&lang=js"

import "./GalleryComponent.vue?vue&type=style&index=0&id=b936f1b6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__